import React, { useCallback } from "react";
import SelectBoxForNotice from "../UIkit/SelectBoxForNotice";
import classes from "./SortingHeader.module.scss";
import WithIconButton from "../UIkit/WithIconButton";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import {
  hideLoadingAction,
  showLoadingAction,
} from "../../reducks/loading/actions";

async function updateOrderNoForProducts(products) {
  try {
    // Firestoreのバッチ処理を使用する
    const batchSize = 500; // Firestoreの1バッチの上限は500件
    let currentBatch = [];

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      const docRef = doc(db, "products", product.id);

      // Firestoreへの更新を準備
      currentBatch.push(
        setDoc(docRef, { orderNo: product.orderNo }, { merge: true })
      );

      // バッチが上限に達するか、最後のアイテムの場合にバッチを実行
      if (currentBatch.length === batchSize || i === products.length - 1) {
        await Promise.all(currentBatch);
        currentBatch = []; // バッチをクリア
      }
    }

    console.log("全ての商品のorderNoを更新しました。");
  } catch (error) {
    console.error("orderNoの更新中にエラーが発生しました:", error);
  }
}

const SortingHeader = (props) => {
  const { categoryList, categoryId, setCategoryId, sortedProducts } = props;
  const dispatch = useDispatch();
  const transition = useCallback((path) => {
    dispatch(push(path));
  }, []);
  const handleSaveButtonClick = async () => {
    // 保存処理
    try {
      dispatch(showLoadingAction("保存中..."));
      await updateOrderNoForProducts(sortedProducts);
      transition("/");
    } catch {
      alert("保存に失敗しました。");
    } finally {
      dispatch(hideLoadingAction());
    }
  };
  return (
    <div className={classes.container}>
      {/*カテゴリ */}
      <div className={classes.leftContents}>
        <SelectBoxForNotice
          label={"カテゴリ"}
          options={categoryList}
          required={true}
          select={(e) => setCategoryId(e)}
          value={categoryId}
          width="130px"
          height="50px"
          color="#4dd0e1"
          fontSize="14px"
          labelFontSize="14px"
        />
      </div>
      <div className={classes.rightContents}>
        <WithIconButton
          label="保存"
          fontSize={14}
          width={90}
          height={32}
          bottom={0}
          color="blue"
          icon={<SaveIcon />} // アイコンをpropsで渡す
          onClick={handleSaveButtonClick}
        />
        <WithIconButton
          label="戻る"
          fontSize={14}
          width={90}
          height={32}
          bottom={0}
          color="grey"
          icon={<CloseIcon />} // アイコンをpropsで渡す
          onClick={() => transition("/product/menu")}
        />
      </div>
    </div>
  );
};

export default SortingHeader;
